<template>
	<div class="progress-block-quiz">
		<div class="progress-block-quiz__wrapper-quiz">
			<div v-for='i of countOfBlocks'
           :key="i"
           :id="(i - 1)"
           :style="{
             '--light-color': lightColor,
              '--main-color': mainColor,
               '--active-color': activeColor,
                '--incorrect-color': incorrectColor,
                 '--light-incorrect-color': lightIncorrectColor,
                 '--correct-color': correctColor,
           }"
           class="progress-block-quiz__item-quiz">
        {{i}}
      </div>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
	mounted() {
		if (document.getElementById("0")) {
			document.getElementById("0").classList.add("active");
		}

		if (this.done) {
			let arr = document.querySelectorAll('.progress-block-quiz__item');
			arr.forEach(i => i.classList.add('done'))
		}
	},

  updated() {
    if (this.showCorrectAnswers) {
      let arr = document.querySelectorAll('.progress-block-quiz__item-quiz');

      arr.forEach(i => {
        if (!this.correctIndexes.includes(Number(i.id)) || this.correctIndexes.length <= 0) {
          i.classList.remove('done')
          i.classList.add('incorrect')
        } else {
          i.classList.remove('done')
          i.classList.add('correct')
        }
      })
    }
  },

  props: {
		countOfBlocks: Number,
		done: Boolean,
    agreeSlide: {
      type: Boolean,
      default: true
    },
    showCorrectAnswers: {
      type: Boolean,
      default: false
    },
    correctIndexes: {
      type: Array,
      default: () => [],
    }
	},

  data() {
    return {
      correctColor: '#3eb049',
      incorrectColor: '#FF0000',
      activeColor: '#0071ba',
    }
  },

  computed: {
    ...mapGetters("app",["getRoleById"]),

    lightColor() {
      return this.changeHex(this.mainColor, 20)
    },

    darkColor() {
      return this.changeHex(this.mainColor, 20, true)
    },

    lightIncorrectColor() {
      return this.changeHex(this.incorrectColor, 40)
    },

    mainColor() {
      return this.getRoleById(3).color
    },

    // activeColor() {
    //   return this.changeHex('#0071ba', 40)
    // },

    // incorrectColor() {
    //   return '#FF0000'
    // },
    //
    // correctColor() {
    //   return '#3eb049'
    // },
  },

	methods: {
		changeSlide(idx) {
			this.$emit('changeSlideMark', idx)
		},

    changeHex(hex, percent = 20, dark = false) {
      const num = parseInt(hex.replace('#', ''), 16)
      const amt = Math.round(2.55 * percent)

      const r = Math.min(255, dark ? (num >> 16) - amt : (num >> 16) + amt)
      const g = Math.min(255, dark ? (num >> 8 & 0x00FF) - amt : (num >> 8 & 0x00FF) + amt)
      const b = Math.min(255, dark ? (num & 0x0000FF) - amt : (num & 0x0000FF) + amt)

      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
    }
	},
}
</script>
<style lang="scss">
@import '@/sass/_vars';

.progress-block-quiz {
	margin-top: 24px;
  padding: .2rem;
  background-color: white;
  border-radius: .5rem;

	&__wrapper-quiz {
		display: flex;
		overflow: hidden;
    justify-content: space-between;
    gap: .2rem;
		box-sizing: border-box;
    border-radius: .3rem;
	}

	&__item-quiz {
    background-color: rgb(223, 223, 223);
		box-sizing: border-box;
		height: 25px;
    flex: 1 1 25%;
		position: relative;
    text-align: center;
    color: white;

		transition: all 0.5s linear;

		>.i {
			position: absolute;
			top: 40%;
			left: 50%;
		}

		&.done {
      background-color: var(--active-color);
      //background: linear-gradient(to right, var(--light-color) 0%, var(--main-color) 50%);
		}

		&.active {
			background-color: var(--active-color);
		}

		&.done.active {
			background: none;
      background-color: var(--active-color);
		}

    &.incorrect {
      //background: linear-gradient(to right, var(--light-incorrect-color) 0%, var(--incorrect-color) 50%);
      background-color: var(--incorrect-color);
    }

    &.correct {
       //background: linear-gradient(to right, var(--light-correct-color) 0%, var(--correct-color) 50%);
      background-color: var(--correct-color);
     }
	}
}
</style>
